import type { Variants } from 'motion/react';

export const variants = {
  hidden: {
    opacity: 0,
    y: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      damping: 8,
      stiffness: 1000,
      velocity: -100,
    },
  },
  exit: {
    y: '-100vh',
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      stiffness: 1000,
    },
  },
} satisfies Variants;
